module.exports = __webpack_public_path__ + "img/H-B-6-unload-connect-shadow.2b83445e.png";